import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Link, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { getSignedAssetUrl, useStore } from '@mcn-platform/models';
import TableList from '../myAccount/TableList';
import ShowMoreText from '../common/ShowMoreText';
const titleFormatter = (fieldValue, item) => (_jsx(Link, { to: `./document/${item?.document?.key}`, children: fieldValue }));
const descriptionFormatter = (fieldValue) => (_jsx(ShowMoreText, { text: fieldValue, cutOff: 240 }));
const MyDocuments = ({ settings: { 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
showArchived = false, }, limitToPageWidth, }) => {
    const [progressList, setProgressList] = useState();
    const navigate = useNavigate();
    const store = useStore();
    // console.log('MyDocuments', store);
    const viewAction = (item) => {
        const rootPath = '.';
        navigate(`${rootPath}/document/${item?.document?.key}`);
    };
    const downloadAction = (documentProgress) => {
        // const rootPath = '.';
        getSignedAssetUrl(documentProgress?.document?.asset, undefined, store).then((signedUrl) => {
            window.open(signedUrl, '_blank');
        });
    };
    useEffect(() => {
        const documentProgressList = store.getCachedList('documentProgress', {
            // portalID: { eq: portal.id },
            ...(!store.isPortalApi) && { customerID: { eq: store.currentCustomer.id } },
            includeInMyDocuments: { eq: true },
        });
        documentProgressList.setRequestedCount(1000);
        setProgressList(documentProgressList);
    }, [store, progressList?.syncState]);
    return (_jsx(Box, { sx: {
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: _jsx(TableList, { items: progressList?.getItems() || [], selectedIDs: [], handleSelectAll: () => { }, handleSelectOne: () => { }, actions: [
                { label: 'View', action: viewAction },
                {
                    label: 'Download',
                    action: downloadAction,
                    // formatter: ({ documentProgress }) => (
                    //   <AssetDownloadLink
                    //     name="Download"
                    //     asset={documentProgress?.document?.asset}
                    //   />
                    // ),
                },
                // { label: 'Download', action: () => {} },
                // { label: 'Copy Link', action: () => {} },
            ], titleField: {
                name: 'document.name',
                label: 'Name',
                formatter: titleFormatter,
            }, secondaryFields: [
                {
                    name: 'document.description',
                    label: 'Description',
                    formatter: descriptionFormatter,
                },
                {
                    name: 'document.publishedAt',
                    label: 'Published',
                },
                // { name: 'status', label: 'Status' },
            ], showSelect: false }) }));
};
MyDocuments.defaultProps = {
    settings: {
        showArchived: false,
    },
    limitToPageWidth: true,
};
MyDocuments.meta = {
    group: 'deliveryPages',
    name: 'My Documents List',
    description: 'Displays a list of documents assigned to the customer.',
    props: [
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
        // {
        //   key: 'settings.showTranscripts',
        //   name: 'Show Transcripts',
        //   type: 'boolean',
        //   description: 'Show the intro video on the card',
        // },
        // {
        //   key: 'settings.showNotes',
        //   name: 'Show Notes',
        //   type: 'boolean',
        //   description: 'Show the course info on the card',
        // },
        // {
        //   key: 'settings.showKicker',
        //   name: 'Show Kicker',
        //   type: 'boolean',
        //   description: 'Show the course headline on the card',
        // },
        // {
        //   key: 'settings.showCTA',
        //   name: 'Show CTA',
        //   type: 'boolean',
        //   description: 'Show the course description on the card',
        // },
        // {
        //   key: 'settings.showOverview',
        //   name: 'Show Overview',
        //   type: 'boolean',
        //   description: 'Show the order by company name on the card',
        // },
    ],
    defaultConfig: {
        type: 'component',
        component: 'MyDocuments',
        props: {},
    },
};
export default observer(MyDocuments);
//# sourceMappingURL=MyDocuments.js.map